import moment from 'moment-timezone'

export const calcDaysCount = event => {
  const { startsAt, endsAt, timezone } = event
  return (
    moment
      .tz(endsAt, timezone || 'Etc/UTC')
      .startOf('day')
      .diff(moment.tz(startsAt, timezone || 'Etc/UTC').startOf('day'), 'days') + 1
  )
}

export const calcDateRange = event => {
  const start = moment.tz(event.startsAt, event.timezone)
  const end = moment.tz(event.endsAt, event.timezone)

  const startMonth = start.format('MMM')
  const startDay = start.format('D')
  const startYear = start.format('YYYY')

  const endMonth = end.format('MMM')
  const endDay = end.format('D')
  const endYear = end.format('YYYY')

  // Same month, same year
  if (startMonth === endMonth && startYear === endYear) {
    return `${startMonth} ${startDay} – ${endDay}, ${startYear}`
  }
  // Different month, same year
  else if (startYear === endYear) {
    return `${startMonth} ${startDay} – ${endMonth} ${endDay}, ${startYear}`
  }
  // Different year
  else {
    return `${startMonth} ${startDay}, ${startYear} – ${endMonth} ${endDay}, ${endYear}`
  }
}
